import { render, staticRenderFns } from "./featureFacilities.vue?vue&type=template&id=5b3b0a2a&scoped=true&"
import script from "./featureFacilities.vue?vue&type=script&lang=js&"
export * from "./featureFacilities.vue?vue&type=script&lang=js&"
import style0 from "./featureFacilities.vue?vue&type=style&index=0&id=5b3b0a2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3b0a2a",
  null
  
)

component.options.__file = "featureFacilities.vue"
export default component.exports